module.exports = __webpack_public_path__ + "static/CosmicForces_HeaderVideo_v04-c95438de7ee0e9fc13e2c017293558da.mp4";